export const taskPresets = [
  "Rewrite the selected content for clarity and executive tone.",
  "Summarize the selected content into concise bullets.",
  "Extract action items, owners, and due dates from the selection.",
  "Draft speaker notes or talking points based on this slide content.",
  "Analyze this table and highlight important trends or risks.",
];
